import { render, staticRenderFns } from "./BellAuthDelete.vue?vue&type=template&id=a27fe2fa&scoped=true"
import script from "./BellAuthDelete.vue?vue&type=script&lang=js"
export * from "./BellAuthDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27fe2fa",
  null
  
)

export default component.exports